import { Bot } from "./types";
import { createRequestType } from "../../helpers/requestType";

export const botFillActionType = createRequestType('FILL_BOTS');
interface botFillRequestAction {
  type: typeof botFillActionType.request;
  payload: any;
}

interface botFillSuccessAction {
  type: typeof botFillActionType.success;
  payload: Bot[];
}

interface botFillFailureAction {
  type: typeof botFillActionType.failure;
  payload: any;
}

export const exploreBotActionType = createRequestType('EXPLORE_BOT');
interface exploreBotAction {
  type: typeof exploreBotActionType.request;
  payload: string;
}

interface exploreSuccessBotAction {
  type: typeof exploreBotActionType.success;
  payload: {};
}

interface exploreFailureBotAction {
  type: typeof exploreBotActionType.failure;
  payload: any;
}

export const changeSelectedBotActionType = createRequestType('CHANGE_SELECTED_BOT');
interface changeSelectedBotAction {
  type: typeof changeSelectedBotActionType.request;
  payload: string;
}

interface changeSelectedBotSuccessAction {
  type: typeof changeSelectedBotActionType.success;
  payload: {};
}

interface changeSelectedBotFailureAction {
  type: typeof changeSelectedBotActionType.failure;
  payload: any;
}

export const saveBotActionType = createRequestType('SAVE_BOT');
interface saveBotAction {
  type: typeof saveBotActionType.request;
  payload: Bot;
}

interface saveSuccessBotAction {
  type: typeof saveBotActionType.success;
  payload: Bot;
}

interface saveFailureBotAction {
  type: typeof saveBotActionType.failure;
  payload: any;
}

export const buildBotActionType = 'BUILD_BOT';
interface buildBotAction {
  type: typeof buildBotActionType;
  payload: {};
}

export type BotActionTypes =  botFillRequestAction 
| botFillSuccessAction 
| botFillFailureAction
| saveBotAction
| saveSuccessBotAction
| saveFailureBotAction
| exploreBotAction
| exploreSuccessBotAction
| exploreFailureBotAction
| changeSelectedBotAction
| changeSelectedBotSuccessAction
| changeSelectedBotFailureAction
| buildBotAction